/* ToolQuest custom file #11 — shared click-to-zoom behavior.
   Companion to assets/toolquest-zoom.css (#10). Pure enhancement: with
   JavaScript off (or no <dialog> support) the page renders exactly as stock.

   Configured by data attributes on its own <script> tag:
     data-tqz-select       CSS selector for candidate images
     data-tqz-min          minimum LARGEST-srcset width that earns zoom
                           (the Kit Finder rule: zoom is earned by resolution,
                           so a placeholder never offers a broken zoom and a
                           better upload turns its own zoom on by itself)
     data-tqz-hint         badge text ('' = icon only)
     data-tqz-icon         badge icon URL (the ToolQuest magnifier mark)
     data-tqz-cursor       cursor image URL (must be transparent-backed)
     data-tqz-cursor-size  cursor render size in device px; hotspot = size/2
                           (INVARIANT carried from the Kit Finder harness)
     data-tqz-label        accessible name for the zoom control
     data-tqz-close        accessible name for the dialog close button

   The enlarged image is the LARGEST srcset candidate — already generated by
   Shopify for the upload, so no extra variant work and no upscale.          */
(function () {
  var s = document.currentScript;
  if (!s || typeof HTMLDialogElement === 'undefined') return;
  var cfg = {
    select: s.getAttribute('data-tqz-select') || '.multicolumn .media > img',
    min: parseInt(s.getAttribute('data-tqz-min') || '1200', 10),
    hint: s.getAttribute('data-tqz-hint') || 'Click to enlarge',
    icon: s.getAttribute('data-tqz-icon') || '',
    cursor: s.getAttribute('data-tqz-cursor') || '',
    cursorSize: parseInt(s.getAttribute('data-tqz-cursor-size') || '36', 10),
    label: s.getAttribute('data-tqz-label') || 'Enlarge image',
    close: s.getAttribute('data-tqz-close') || 'Close'
  };

  function biggest(img) {
    var best = null;
    (img.getAttribute('srcset') || '').split(',').forEach(function (c) {
      var p = c.trim().split(/\s+/);
      var w = parseInt((p[1] || '').replace(/w$/, ''), 10);
      if (p[0] && w && (!best || w > best.w)) best = { url: p[0], w: w };
    });
    return best;
  }

  var dlg = null;
  function ensureDialog() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'tqz-dialog';
    var inner = document.createElement('div');
    inner.className = 'tqz-inner';
    var im = document.createElement('img');
    im.alt = '';
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'tqz-close';
    x.setAttribute('aria-label', cfg.close);
    inner.appendChild(im);
    inner.appendChild(x);
    dlg.appendChild(inner);
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    /* Native <dialog> closes on Escape; duplicated for embedded contexts
       (the theme editor's preview iframe) where the key may not arrive. */
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.stopPropagation(); dlg.close(); }
    });
    x.addEventListener('click', function () { dlg.close(); });
    return dlg;
  }

  function enhance(img) {
    var big = biggest(img);
    if (!big || big.w < cfg.min) return;
    var host = img.parentElement;
    if (!host || host.classList.contains('tqz-host')) return;
    host.classList.add('tqz-host');
    if (cfg.cursor) {
      var hot = Math.round(cfg.cursorSize / 2); /* hotspot = size/2, never typed independently */
      host.style.setProperty('--tqz-cursor', 'url(' + cfg.cursor + ') ' + hot + ' ' + hot + ', zoom-in');
    }
    if (cfg.hint || cfg.icon) {
      var badge = document.createElement('span');
      badge.className = 'tqz-hint';
      badge.setAttribute('aria-hidden', 'true');
      if (cfg.icon) {
        var ic = document.createElement('img');
        ic.className = 'tqz-icon';
        ic.src = cfg.icon;
        ic.alt = '';
        ic.loading = 'lazy';
        badge.appendChild(ic);
      }
      if (cfg.hint) {
        var tx = document.createElement('span');
        tx.className = 'tqz-text';
        tx.textContent = cfg.hint;
        badge.appendChild(tx);
      }
      host.appendChild(badge);
    }
    host.setAttribute('role', 'button');
    host.tabIndex = 0;
    host.setAttribute('aria-label', cfg.label);
    function open() {
      var d = ensureDialog();
      var im = d.querySelector('img');
      im.src = big.url;
      im.alt = img.alt || '';
      d.showModal();
    }
    host.addEventListener('click', open);
    host.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  }

  function init() { document.querySelectorAll(cfg.select).forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
